import React, { useMemo } from 'react'
import { useLoaderData } from 'react-router-dom'
import LoadPageComponents from './LoadPageComponents'
const Single = props => {
  const pageArray = useLoaderData()[0]

  const reactPageData = useMemo(() => pageArray?.acf, [pageArray])

  const pages = useMemo(
    () =>
      reactPageData &&
      Object?.keys(reactPageData)
        ?.filter((key, index) => reactPageData[key]?.page_order && key)
        ?.sort((a, b) =>
          reactPageData[a]?.page_order > reactPageData[b]?.page_order
            ? 1
            : reactPageData[a]?.page_order < reactPageData[b]?.page_order
            ? -1
            : 0
        ),
    [reactPageData]
  )
  return (
    <div>
      {pageArray?.content && <div
        className='Post w-full max-w-sitemax m-auto mb-24'
        dangerouslySetInnerHTML={{ __html: pageArray?.content?.rendered }}
      ></div>}
      <div className='page-container mt-12'>
        {pages &&
          pages?.map((page, index) => (
            <LoadPageComponents
              key={index}
              page={page}
              data={{ ...reactPageData[page] }}
            />
          ))}
      </div>
    </div>
  )
}
export default Single
